import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'


interface OrderStatisticsState extends ListState<any>{
}
class OrderStatisticsMutations extends ListMutations<any>{

}
class OrderStatisticsModule extends ListModule<OrderStatisticsState,any,any>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10000,
        list: new Array<any>(),
        loading:false,
    }
    actions={
        async getAll(context:ActionContext<OrderStatisticsState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/ProductOrder/GetProductOrderStatisticsList',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as  Array<any>;
            context.state.totalCount=page.length;
            context.state.list=page;
        },
    };
    mutations={
        setCurrentPage(state:OrderStatisticsState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:OrderStatisticsState,pagesize:number){
            state.pageSize=pagesize;
        }
    }
}
const orderStatisticsModule=new OrderStatisticsModule();
export default orderStatisticsModule;